import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';

const ExpertiseSection = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  const services = [
    {
      icon: 'ri-instagram-line',
      title: 'Sosyal Medya Yönetimi',
      description: 'Sigorta sektörüne özel içerik stratejisi ve topluluk yönetimi ile markanızı güçlendiriyoruz.',
      path: '/hizmetler/sosyal-medya',
    },
    {
      icon: 'ri-advertisement-line',
      title: 'Meta & Google Reklamları',
      description: 'Hedef kitleye özel kampanyalarla lead maliyetlerinizi düşürüyor, dönüşüm oranlarınızı artırıyoruz.',
      path: '/hizmetler/dijital-reklamcilik',
    },
    {
      icon: 'ri-window-line',
      title: 'Web Tasarımı',
      description: 'CRM entegrasyonlu, dönüşüm odaklı web siteleri ve landing page tasarımları geliştiriyoruz.',
      path: '/hizmetler/web-tasarim',
    },
    {
      icon: 'ri-database-2-line',
      title: 'CRM & Otomasyon',
      description: 'Poliçe formlarından WhatsApp entegrasyonuna kadar tüm süreçlerinizi otomatikleştiriyoruz.',
      path: '/hizmetler/crm-otomasyon',
    },
    {
      icon: 'ri-palette-line',
      title: 'Marka Kimliği',
      description: 'Güven veren, profesyonel kurumsal kimlik tasarımları ile markanızı öne çıkarıyoruz.',
      path: '/hizmetler/marka-kimligi',
    },
    {
      icon: 'ri-video-line',
      title: 'İçerik & Video Prodüksiyon',
      description: 'Güven veren video içerikler ve motion graphics ile müşterilerinize ulaşın.',
      path: '/hizmetler/video-produksiyon',
    },
  ];

  return (
    <section ref={ref} className="py-16 bg-platinum">
      <div className="max-w-[1440px] mx-auto px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <p className="font-poppins font-semibold text-[12px] text-[#007dff] uppercase tracking-wider mb-3">
            Neden Farklıyız?
          </p>
          <h2 className="font-poppins font-semibold text-3xl lg:text-4xl text-gray-900 mb-4">
            Sadece Sigorta Sektörüne Özel Ajans
          </h2>
          <p className="font-poppins text-base text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Sigorta dilini biliyoruz, müşterinizi tanıyoruz. 360 derece dijital büyüme çözümleriyle acentenizi zirveye taşıyoruz.
          </p>
        </motion.div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <Link
                to={service.path}
                className="block group bg-white rounded-2xl p-6 shadow-sm hover:shadow-xl hover:border-2 hover:border-[#007dff] transition-all duration-300 hover:-translate-y-2 cursor-pointer"
              >
                {/* Icon */}
                <div className="w-12 h-12 flex items-center justify-center bg-[#007dff]/10 rounded-xl mb-4 group-hover:bg-[#007dff] transition-all duration-300">
                  <i className={`${service.icon} text-2xl text-[#007dff] group-hover:text-white transition-colors duration-300`}></i>
                </div>

                {/* Title */}
                <h3 className="font-poppins font-semibold text-base text-gray-900 mb-3 group-hover:text-[#007dff] transition-colors duration-300">
                  {service.title}
                </h3>

                {/* Description */}
                <p className="font-poppins text-[13px] text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExpertiseSection;